import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import { SnackbarProvider } from './Components/Snackbar/SnackBarContext';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import store from './StateManagement/store';
import { ThemeContextProvider } from './Context/ThemeContext';


ReactDOM.render(
  <Provider store={store}>
   <ThemeContextProvider>
     <SnackbarProvider>
      <App />
    </SnackbarProvider>
   </ThemeContextProvider>
  </Provider>,
  document.getElementById('root')
);

reportWebVitals();
